// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"231":"servicecenter","238":"sylius"}[chunkId] + "." + {"231":"a10a64f56ef0f453","238":"f18c4d7f1f904b65"}[chunkId] + ".css";
};